module.exports = __webpack_public_path__ + "static/pools-litepaper-eb049d3c9cff4354bed61c468abbe1ac.png";